import React from 'react';

const InfoIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 6a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9zm0 16.875c-4.342 0-7.875-3.533-7.875-7.875 0-4.342 3.533-7.875 7.875-7.875 4.342 0 7.875 3.533 7.875 7.875 0 4.342-3.533 7.875-7.875 7.875zm0-10.406a.844.844 0 1 0 0-1.688.844.844 0 0 0 0 1.688zm1.688 5.906h-1.125v-3.938a.564.564 0 0 0-.563-.562h-1.125a.564.564 0 0 0-.563.563c0 .309.254.562.563.562h.563v3.375h-1.126a.564.564 0 0 0-.562.563c0 .309.253.562.563.562h3.374a.563.563 0 0 0 0-1.125z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InfoIcon;
